import {
  inject,
  Inject,
  Injectable,
  REQUEST,
  REQUEST_CONTEXT,
} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';
import { IUserData } from '../interfaces/user-data.interface';
import { StorageLocalModel } from '../models/storage.model';
import { PlatformService } from './platform.service';
import { StorageCookieModel } from '../models/cookie.storage.model';

@Injectable({ providedIn: 'root' })
export class StorageService {
  userAuth!: StorageCookieModel<string>;
  // userData!: StorageLocalModel<IUserData>;
  i18n!: StorageCookieModel<string>;
  cookeyApprove!: StorageLocalModel<boolean>;

  //  / g_state: StorageCookieModel<string>;
  constructor(
    private cookieService: CookieService,
    @Inject(DOCUMENT) private document: Document,
    private pt: PlatformService,
  ) {
    const request: any = inject(REQUEST_CONTEXT, { optional: true });
    // console.log('REQUEST_CONTEXT', request?.lang);

    this.userAuth = new StorageCookieModel<string>(
      'userAuth',
      this.cookieService,
      undefined,
      false,
      this.document,
    );
    this.cookeyApprove = new StorageLocalModel<boolean>(
      'cookeyApprove',
      this.pt.isBrowser,
    );
    this.i18n = new StorageCookieModel<string>(
      'lang',
      this.cookieService,
      request?.lang ?? 'en',
      false,
      this.document,
    );

    // this.g_state = new StorageCookieModel<string>(
    //   'g_state',
    //   this.cookieService,
    //   '',
    //   false,
    //   this.document,
    // );
  }
}
